import { useMsal } from '@azure/msal-react';
import React, { useState, useRef, useEffect, KeyboardEvent, ChangeEvent } from 'react';

import auth_guid from "../../auth_guid.json"
import axios, { AxiosRequestConfig } from "axios";
import { useAdmin } from '../../Utils/AdminContext';
interface EditableTitleProps {
  customLabelValue: {
    table : string,
    property: string,
    value : string,
    id : string,
  } | undefined;
  handleUpdateEditableTitle : (id : string , value : string) => void;
}

const EditableTitle: React.FC<EditableTitleProps> = ({
  customLabelValue = {
    table : "",
    property : "",
    value : "",
    id : "",
  },
  handleUpdateEditableTitle
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [text, setText] = useState<string>(customLabelValue.value);
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
  const { isAdmin, setIsAdmin } = useAdmin();

  useEffect(() => {
    if (isEditing && textAreaRef.current) {
      textAreaRef.current.focus();
      textAreaRef.current.select();
    }
  }, [isEditing]);
  useEffect(() => {
    setText(customLabelValue.value);
  }, [customLabelValue.value]);
  useEffect(() => {
    setUserTokenFromInstance();
  }, []);

  const [userToken, setuserToken] = useState<string | null>();
  const { instance, accounts } = useMsal();
  const handleClick = (): void => {
    if (isAdmin) {
      setIsEditing(true);
    }
  };
  var scopeUrl =
    process.env.NODE_ENV === "production"
    ? "api://"+auth_guid.prod.tenantId+"/User.Read"
    : "https://CBEDevelopWebappTest.onmicrosoft.com/"+auth_guid.local.tenantId+"/User.Read";

  const config =
    process.env.NODE_ENV === "production"
      ? require("../../Config.prod").default
      : require("../../Config.local").default;
  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>): void => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      setIsEditing(false);
      onSubmit?.(text);
    }
    if (e.key === 'Escape') {
      setIsEditing(false);
      setText(customLabelValue.value);
    }
  };

  const handleBlur = (): void => {
    setIsEditing(false);
  };

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>): void => {
    setText(e.target.value);
  };
  const setUserTokenFromInstance = async () => {
    if ( userToken == undefined || userToken == null ) {
      const b2cResponse = await instance.acquireTokenSilent({
        scopes: [scopeUrl],
        account: accounts[0],
      });
      setuserToken(b2cResponse.accessToken);
    }
    
  }
  
  const onSubmit = async (value:string) =>{
      setUserTokenFromInstance();
      const axiosConfig = {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios
        .patch(
          config.apiUrl + "/LabelValues/" + customLabelValue.id + "/Value",
          { newValue : value },
          axiosConfig
        )
        .then((response) => {
          if(response.status === 200)
          {
            handleUpdateEditableTitle(customLabelValue.id, text);
          }
        })
        .catch((error) => {});
      }
  if (isEditing) {
    return (
      <textarea
        ref={textAreaRef}
        value={text}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        rows={1}
        style={{ minWidth: "500px" }}
      />
    );
  }

  return (
    <div 
      onClick={handleClick}
    >
      {text}
    </div>
  );
};

export default EditableTitle;